import { createTheme } from "@mui/material/styles";

// Layout heights root -> navbar / content
const rootHeight = "100vh";
const appNavBarHeight = "4.3rem";

// Extend module '@mui/material/styles' to add new properties
declare module "@mui/material/styles" {
  interface Theme {
    customTransitions: {
      colorTransition: string;
    };
    customLayoutHeight: {
      rootHeight: string;
      appNavBarHeight: string;
    };
  }
  interface Palette {
    customColors: {
      positiveVariationColor: string;
      negativeVariationColor: string;
      generateVideoColor: string;
      generateSummaryColor: string;
      newsPaperColor: string;
      disabledColor: string;
      mainLower: string;
    };
  }
  // to work in sync with `createTheme`
  interface ThemeOptions {
    customTransitions?: {
      colorTransition?: string;
    };
    customLayoutHeight?: {
      rootHeight?: string;
      appNavBarHeight?: string;
    };
  }
  interface PaletteOptions {
    customColors?: {
      positiveVariationColor?: string;
      negativeVariationColor?: string;
      generateVideoColor?: string;
      generateSummaryColor?: string;
      newsPaperColor?: string;
      disabledColor: string;
      mainLower: string;
    };
  }
}

const BaseTheme = createTheme({
  typography: {
    fontFamily: "Manrope"
  },
  palette: {
    mode: "light",
    primary: {
      main: "#ff7300",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#fa6375",
      contrastText: "#ffffff"
    },
    background: {
      default: "#f7f7f7"
    },
    error: {
      main: "#ff0004"
    },
    success: {
      main: "#28a745"
    },
    customColors: {
      positiveVariationColor: "#027A48",
      negativeVariationColor: "#B42318",
      generateVideoColor: "#f3c518",
      generateSummaryColor: "#14a6d9",
      newsPaperColor: "#D8D8D8",
      disabledColor: "#DBDBDB",
      mainLower: "#ff7300"
    }
  },
  shape: {
    borderRadius: 5
  },
  customTransitions: {
    colorTransition: "all 150ms ease-in-out"
  },
  customLayoutHeight: {
    rootHeight: rootHeight,
    appNavBarHeight: appNavBarHeight
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: ({ theme }) => ({
          borderRadius: 7,
          fontSize: 16,
          textTransform: "none",
          fontWeight: 600,
          backgroundColor: theme.palette.customColors.mainLower, // o theme.palette.primary.main
          "&:hover": {
            backgroundColor: theme.palette.customColors.mainLower
          }
        })
      }
    }
  }
});

export default BaseTheme;
